import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UtilService } from './shared/services/util.service';
import { Subject, takeUntil } from 'rxjs';
import { SpinnerManualComponent } from '@shared/components/spinner-manual/spinner-manual.component';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [
  RouterModule,
  SpinnerManualComponent
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'polizas';
  opened = true;
  private destroy$ = new Subject<void>();

  constructor(private utilSvc: UtilService) {}

  ngOnInit(): void {
    this.utilSvc.sidenavOpen$.pipe(takeUntil(this.destroy$)).subscribe((sidenav) => {
      this.opened = sidenav;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
